<template>
  <div class="app-container">
    <div v-if="roleIsCustomer" class="welcome"></div>

    <template v-else>
      <swiper class="main-swiper" :options="swiperOption">
        <swiper-slide>
          <el-row :gutter="10" type="flex" style="flex-wrap: wrap">
            <el-col :span="14" class="left-col">
              <div class="cbox-p14">
                <div class="chart-title flx-justify-between">
                  <div>委托单下单趋势</div>
                  <el-date-picker
                    v-model="searchEntustYear"
                    type="year"
                    placeholder="选择年"
                    :clearable="false"
                    value-format="yyyy"
                    @change="handleQueryEntust()"
                  ></el-date-picker>
                </div>
                <div v-loading="entrustLoading" class="chart-box">
                  <LineEntrust chartsId="LineEntrust" :data="entrustData" />
                </div>
              </div>
              <div class="cbox-p14">
                <div class="chart-title flx-justify-between">
                  <div>委托样品检测工作量统计</div>
                  <el-date-picker
                    class="search-date-range"
                    v-model="searchWorkRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="handleQueryWork()"
                    :clearable="false"
                  ></el-date-picker>
                </div>
                <div v-loading="workLoading" class="chart-box">
                  <BarWork chartsId="BarWork" :data="workData" />
                </div>
              </div>
            </el-col>
            <el-col :span="10" class="right-col">
              <div class="cbox-p14">
                <div class="chart-title flx-justify-between">
                  <div>样品检测统计</div>
                  <el-date-picker
                    class="search-date-range"
                    v-model="searchCategoryRange"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="yyyy-MM-dd"
                    @change="handleQueryCategory()"
                    :clearable="false"
                  ></el-date-picker>
                </div>
                <div v-loading="categoryLoading" class="chart-box">
                  <PieCategory chartsId="PieCategory" :data="categoryData" />
                </div>
              </div>
              <div class="cbox-p14 small-height">
                <div class="chart-title flx-align-center">待办事项</div>

                <div class="todo-list chart-box">
                  <div v-for="(item, index) in todoData" :key="index" class="todo-item flx-justify-between">
                    <div class="left">
                      <span>您有</span>
                      <span class="num">{{ item.num }}</span>
                      <span>{{ item.title }}</span>
                    </div>
                    <div class="right">
                      <el-link type="primary" @click="handleTodo(item.url)">查看</el-link>
                    </div>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
        </swiper-slide>
        <!-- 
        <swiper-slide>
        </swiper-slide> -->
      </swiper>
      <!-- 
      <div class="swiper-button-prev el-icon-caret-left"></div>
      <div class="swiper-button-next el-icon-caret-right"></div> -->
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

import LineEntrust from './components/LineEntrust';
import PieCategory from './components/PieCategory';
import BarWork from './components/BarWork';

import {
  getSampleCntDAByTestUser,
  getSampleCntDABySampleType,
  getEntrustmentCntByMonthForYear,
  getMtApplyCount
} from '@/api/home';

export default {
  components: { Swiper, SwiperSlide, LineEntrust, PieCategory, BarWork },
  props: {},
  data() {
    return {
      roleIsCustomer: false,
      entrustLoading: false,
      searchEntustYear: '',
      entrustData: [],
      categoryLoading: false,
      searchCategoryRange: [],
      categoryData: [],
      workLoading: false,
      searchWorkRange: [],
      workData: [],
      swiperOption: {
        allowTouchMove: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      },
      testVisible: false,
      todoData: []
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {},
  methods: {
    async handleQueryEntust() {
      this.entrustLoading = true;
      try {
        const { data } = await getEntrustmentCntByMonthForYear({ year: this.searchEntustYear });
        this.entrustData = data || [];
      } finally {
        this.entrustLoading = false;
      }
    },
    async handleQueryCategory() {
      const startDate = this.searchCategoryRange?.[0] ?? null;
      const endDate = this.searchCategoryRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      this.categoryLoading = true;
      try {
        const { data } = await getSampleCntDABySampleType({ startTime, endTime });
        this.categoryData = data || [];
      } finally {
        this.categoryLoading = false;
      }
    },
    async handleQueryWork() {
      const startDate = this.searchWorkRange?.[0] ?? null;
      const endDate = this.searchWorkRange?.[1] ?? null;
      const startTime = startDate ? startDate + ' 00:00:00' : null;
      const endTime = endDate ? endDate + ' 23:59:59' : null;

      this.workLoading = true;
      try {
        const { data } = await getSampleCntDAByTestUser({ startTime, endTime });
        this.workData = data || [];
      } finally {
        this.workLoading = false;
      }
    },
    async getMtApplyCount() {
      const { data } = await getMtApplyCount({ authBy1: this.userInfo.id, authBy2: this.userInfo.id });

      const todoList = [];
      if (data && data.authByCount1 > 0) {
        todoList.push({
          title: '条物料出库待审核',
          num: data.authByCount1,
          url: '/materialManage/stockAudit'
        });
      }
      if (data && data.authByCount2 > 0) {
        todoList.push({
          title: '条物料出库待批准',
          num: data.authByCount2,
          url: '/materialManage/stockAudit/approve'
        });
      }
      this.todoData = todoList;
    },
    handleTodo(pageUrl) {
      this.$router.push(pageUrl);
    }
  },
  created() {
    const nowYear = moment().format('YYYY');
    this.searchEntustYear = nowYear;
    this.searchWorkRange = [`${nowYear}-01-01`, `${nowYear}-12-31`];
    this.searchCategoryRange = [`${nowYear}-01-01`, `${nowYear}-12-31`];

    this.roleIsCustomer = this.userInfo.roleIds.indexOf('2c942eb494e511740194fe6cb2cd0405') > -1;
  },
  mounted() {},
  activated() {
    this.handleQueryEntust();
    this.handleQueryCategory();
    this.handleQueryWork();
    this.getMtApplyCount();
  } //页面有keep-alive触发
};
</script>

<style lang="scss" scoped>
.welcome {
  width: 100%;
  height: 100%;
  background: #ffffff url(~@/assets/images/bg-welcome.png) no-repeat center center/contain;
}

.main-swiper {
  width: 100%;
  // height: calc(100% - 30px);
  height: 100%;

  ::v-deep .swiper-wrapper {
    box-sizing: border-box;
  }
  .swiper-slide {
    width: 100%;
  }
}

.swiper-button-prev {
  top: initial;
  bottom: 0;
  left: calc(50% - 20px);
  width: 28px;
  height: 28px;
  font-size: 24px;

  &::after {
    display: none;
  }
}
.swiper-button-next {
  top: initial;
  bottom: 0;
  left: calc(50% + 20px);
  width: 28px;
  height: 28px;
  font-size: 24px;

  &::after {
    display: none;
  }
}
.el-row {
  height: 100%;

  .el-col {
    height: 100%;
  }
}

.left-col {
  display: flex;
  flex-direction: column;

  > div {
    flex: 1;

    & + div {
      margin-top: 10px;
    }
  }
}

.right-col {
  display: flex;
  flex-direction: column;

  > div {
    flex: 1;

    & + div {
      margin-top: 10px;
    }
    &.small-height {
      flex: 0 0 40%;
    }
  }
}

.chart-title {
  min-height: 42px;
  width: 100%;
}

.chart-box {
  width: 100%;
  height: calc(100% - 42px);
}

.small-height {
  flex: 0 0 100px;
  min-height: 0;

  .todo-list {
    width: 100%;
    overflow: hidden;
    overflow-y: auto;

    .todo-item {
      font-size: 16px;
      color: #333;
      padding: 10px;
      border-bottom: 1px solid #f1f5f9;

      &:last-of-type {
        border-bottom: none;
      }
      .num {
        color: #1890ff; // 用品牌色突出数字
        font-weight: bold;
      }

      .right .el-link {
        font-size: 14px;
      }
    }
  }
}
</style>
